import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <footer>
                <a href="mailto: gary@bbg.im">Email: gary@bbg.im</a>
                <p>&copy; 2025 Best Business Guide Limited. All rights reserved.</p>
            </footer>
        )
    }
}

export default Footer;